module.exports = __webpack_public_path__ + "fonts/Roboto-Light.fd46dc4.woff";